export default __webpack_public_path__ + "static/media/illu.fe447378.png";